export class SetGroupRoleAction {
  public static readonly type = '[Authorisation] SetGroupRoleAction';
  constructor(
    public readonly userId: string,
    public readonly groupId: string,
  ) {}
}
